// Main menu lets the user pick which level he'd like to play.

import MainMenu from 'app/src/game/MainMenu';
import * as React from 'react';

export default function MainMenuPage(): React.ReactElement | null {
	return <MainMenu />;
}
